import type { PublicEvent } from '@irace/shared';

const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

/**
 * Apply the event's brand colour to the document.
 *
 * The value is validated before it reaches CSS: `branding` is a
 * pass-through object in the OpenAPI contract, so treating its contents as
 * trusted style input would let a config typo — or a future
 * organizer-supplied value — inject arbitrary CSS.
 */
export function applyBranding(event: PublicEvent): void {
  const branding = event.branding as { brand_color?: unknown } | undefined;
  const color = branding?.brand_color;
  if (typeof color === 'string' && HEX_COLOR.test(color)) {
    document.documentElement.style.setProperty('--brand', color);
  }
}
